import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-notre-equipe',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './notre-equipe.component.html',
  styleUrl: './notre-equipe.component.scss'
})
export class NotreEquipeComponent implements OnInit {
  title = 'Notre Équipe';
  subtitle = 'Des professionnels de l\'assurance à votre service';
  heroImage = 'assets/static_pages_images/notre-equipe.JPG';
  
  breadcrumbs = [
    { label: 'Notre Équipe', link: undefined }
  ];

  prevPage = {
    title: 'Notre Histoire',
    link: '/qui-sommes-nous'
  };

  nextPage = {
    title: 'Notre Approche',
    link: '/notre-approche'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

}
